import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useSelector } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface IndustryProps {
  open: boolean;
  handleClose: () => void;
  industryName: any;
  setIndustryName: any;
  selectedShareuid: any;
  setSelectedSharedUid: any;
  selectedRowData: any;
  setSelectedRowData: any;
  setMetaIndustryType: any;
}

function EditIndustryModal({
  open,
  handleClose,
  industryName,
  setIndustryName,
  selectedShareuid,
  setMetaIndustryType,
}: IndustryProps) {
  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;

  const [loading, setLoading] = useState(false);

  const UpdateNewDeviceType = async () => {
    const data = {
      industry_name: industryName,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.updateMetaIndustry(
          oauthTokenHeader,
          data,
          selectedShareuid
        );
      } else {
        throw new Error("User doesn't have permissions to create Devie Type");
      }
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaIndustry(
          oauthTokenHeader,
          setMetaIndustryType
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaIndustry(
        oauthTokenHeader,
        setMetaIndustryType
      );
    }
  };

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Edit New Industry
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid item xs={12}>
                <TextField
                  value={industryName}
                  onChange={(e: any) => setIndustryName(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Industry Name *" // Set your label here
                  placeholder="Enter unique Industry Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              This is a mandatory field.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!industryName}
                onClick={UpdateNewDeviceType}
                data-tracker="235"
              >
                Save changes <SaveOutlinedIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
}

export default EditIndustryModal;
